import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import PermissaoList from './PermissaoList';
import React, { SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Messages } from 'primereact/messages';
import { Dialog } from 'primereact/dialog';
import { Controller, useForm } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import postPermission from '../../service/postPermission';
import putPermission from '../../service/putPermission';
import { Checkbox } from 'primereact/checkbox';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import getPermissao from '../../service/getPermissao';
import { InputNumber } from 'primereact/inputnumber';
import getPermissaoTipoFiltro from '../../service/getPermissaoTipoFiltro';
import { Panel } from 'primereact/panel';
import { Divider } from 'primereact/divider';
import { PickList } from 'primereact/picklist';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';

export default function PermissaoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [permission, setPermission] = useState<any | null>(null);
  const [permissionDad, setPermissionDad] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const [selectedTipoConsulta, setselectedTipoConsulta] = useState<number|undefined>();
  const [date, setDate] = useState(new Date());
  const [checked, setChecked] = useState(false);
  const [bilhetarAgrupador, setBilhetarAgrupador] = useState(false);
  const [nodes, setNodes] = useState<any[]>([]);
  const [expandedKeyss] = useState<any>({'QUODPF': true});
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null); 
  const [idsPermissoes, setIdsPermissoes] = useState<any[]>([]);
  const [source, setSource] = useState([]);
  const [target, setTarget] = useState<any[]>([]);
  const [filtros, setFiltros] = useState<any[]>([]);
  const [listInactivePermissions, setListInactivePermissions] = useState(false);
  const identificadoresRef = useRef<string[]>([]);
  const permissionRef = useRef<any>(null);
  permissionRef.current = permission;

  const defaultValues = useMemo(() => {
  
    return {
      identificador: '',
      descricao: '',
      ordenacao: null,
      fornecedorConsulta: '',
      informativo: '',
      inativa: null,
      composicaoConsulta: ''
    };
}, [permission]);
  const footerContent = (
  <React.Fragment>
        <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
        <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => resetForm()} className="p-button-text" />
  </React.Fragment>
  );
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setPermission({id:undefined})}}/>
        <div style={{ marginLeft: '8rem', display: 'inline-flex', alignItems: 'center' }}>
          <Checkbox 
            inputId="listInactivePermissions" 
            onChange={e => setListInactivePermissions(e.checked ? true : false)} 
            checked={listInactivePermissions}
          />
          <label htmlFor="listInactivePermissions" className="ml-2">Listar Também Permissões Inativas</label>
        </div>
    </React.Fragment>
);

const {
  control,
  formState: { errors},
  handleSubmit,
  reset,
  setValue
} = useForm({ defaultValues, mode: 'onChange' });

const collectIdentificadores = (permissoes: any[], acc: string[]) => {
  permissoes.forEach((element: any) => {
    if (element.value) {
      acc.push(element.value);
    }
    if (element.permissoes) {
      collectIdentificadores(element.permissoes, acc);
    }
  });
  return acc;
};

useEffect(() => {
  getPermissao().then(data => {
    identificadoresRef.current = collectIdentificadores(data, []);
  });
}, [date]);

const onSubmit = (data:any) => {
  data.identificador && save(data);
};

const resetForm = () => {
  setChecked(false);
  setBilhetarAgrupador(false);
  setselectedTipoConsulta(undefined);
  setPermission(null);
  setPermissionDad(null);
  setSelectedKeys(null);
  setIdsPermissoes([]);
  setTarget([]);
  setSource([]);
  setFiltros([]);
  reset();
}

const tiposConsulta = [
  { name: 'Selecione', code: null },
  { name: 'Consulta Pessoa Física', code: 0 },
  { name: 'Consulta Pessoa Jurídica', code: 1 },
  { name: 'Consulta Pessoa  PF/PJ', code: 2 }
];

const save = (data:any) => {
  const opcoes: string[] = [];
    if(selectedKeys){
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
  const permissao = {
    id: permission.id? permission.id : undefined,
    label: data.descricao,
    value: data.identificador,
    ordenacao: data.ordenacao,
    fornecedorConsulta: data.fornecedorConsulta,
    idPai: permissionDad?.id,
    tipoConsulta: selectedTipoConsulta,
    agrupadorConsulta: checked,
    bilhetarAgrupador: bilhetarAgrupador,
    consultas:opcoes,
    informativo: data.informativo,
    composicaoConsulta: data.composicaoConsulta,
    filtros:filtros,
    inativa: data.inativa
  }
  window.scrollTo(0, 0);
 
  savePermission(permissao)
} 
const savePermission = (permission:any) => {
  if(permission.id){
    putPermission(permission).then(data => {
      if(data.includes('Erro')){
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
             
          ]);
        }
      }
      else{
        setDate(new Date())
        resetForm();
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
             
          ]);
        }
      }
    })
  }
  else{
    postPermission(permission).then(data => {
      if(data.includes('Erro')){
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
             
          ]);
        }
      }
      else{
        setDate(new Date())
        resetForm();
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
             
          ]);
        }
      }
    })
  }
  
  
}
const createPermissoes = () => {
  if(selectedTipoConsulta == 0 || selectedTipoConsulta == 1){
    getPermissao().then(data => {
      const optionsPF = data.filter((f: {
        agrupadorConsulta: boolean; tipoConsulta: string; 
}) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))
optionsPF.sort((s1:{ label: string}, s2:{label: string}) => {
  const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
  const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
})      
optionsPF.forEach((element: {
        children: any; label: string; value: string; composicaoConsulta: string; permissoes:any[]
}) => {

        verifyChecked(element);
        if(element.children){
          element.children.forEach((child:any) => {verifyChecked(child)})
        }
        option.push({label:element.value, composicaoConsulta:element.composicaoConsulta, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
          agrupadorConsulta: boolean; tipoConsulta: string; 
}) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))) : element.children });
      });
    })
  }
  
  const option : any[] = [];
  
  
 
  return option;
}
const createPermissoesFilhos = (permissoes:any[]) => {
  const option : any[] = [];
  if(permissoes){
    permissoes.sort((s1:{ label: string}, s2:{label: string}) => {
      const nameA = s1.label.toUpperCase(); // ignore upper and lowercase
      const nameB = s2.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    
      // names must be equal
      return 0;
    })
    permissoes.forEach((element: {
      children: any; label: string; value: string; composicaoConsulta: string; permissoes:any[]
}) => {


      verifyChecked(element);
      if(element.children){
        element.children.forEach((child:any) => {verifyChecked(child)})
      }

      option.push({label:element.value, composicaoConsulta:element.composicaoConsulta, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
        agrupadorConsulta: boolean; tipoConsulta: string; 
}) => f.agrupadorConsulta == false && (f.tipoConsulta === (selectedTipoConsulta == 0 ? 'PF' : 'PJ') || f.tipoConsulta === 'PFPJ'))) : element.children});
    });
  }
  return option;
}

const nodeTemplate = (node: any) => {
  return (
    <div>
      <span style={{ fontWeight: 'bold' }}>{node.label}</span>
      {node.composicaoConsulta && (
        <div style={{ fontSize: '0.8rem', fontWeight: 'normal', color: '#6c757d' }}>{node.composicaoConsulta}</div>
      )}
    </div>
  );
};

const verifyChecked = (element:any) => {

  if(permission && permission.consultas){
    
    const checked = permission.consultas.find((k:string) => k == element.value);

    if(checked){
      idsPermissoes.push(element.value)
      const selectedKeysChecked: SetStateAction<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null> = {
    
      }

      idsPermissoes.forEach(id => {
        selectedKeysChecked[id] = {
          partialChecked: false,
          checked: true
        }
      });
      
     setSelectedKeys(selectedKeysChecked);
    }
  }
}

const edit = (permission:any) => {
  setValue('descricao', permission.label);
  setValue('identificador', permission.value);
  setValue('ordenacao', permission.ordenacao);
  setValue('informativo', permission.informativo);
  setValue('composicaoConsulta', permission.composicaoConsulta);
  setValue('fornecedorConsulta', permission.fornecedorConsulta);
  setValue('inativa', permission.inativa);
  setChecked(permission.agrupadorConsulta)
  setBilhetarAgrupador(permission.bilhetarAgrupador);
  setFiltros(permission.filtros)
  if(permission.filtros){
    const listaTarget :any[] = [];
    permission.filtros.map((filtro:any) => {
      listaTarget.push({value:filtro.tipoFiltro, label:filtro.descricao})
    })
    setTarget(listaTarget)
    setSource(source.filter((s1:any) => listaTarget.filter((s2:any) => s1.value === s2.value).length === 0))
  }
  setPermission(permission)
  if(permission.idPai){
    setTimeout(() => {
      setPermissionDad({id:permission.idPai, value: permission.valuePai, label: permission.labelPai})
    }, 100);
    
  }
  if(permission.tipoConsulta){
    setselectedTipoConsulta((permission.tipoConsulta == 'PF' ? 0 : (permission.tipoConsulta == 'PJ' ? 1 : (permission.tipoConsulta == 'AUTO' ? 3 : 2))))
  }
  
} 
const onChangePickList = (event:any) => {
  setSource(event.source);
  setTarget(event.target);
  if(event.target && event.target.length > 0){
    const lista : any[] = [];
    event.target.map((f:any) => {
      lista.push({tipoFiltro: f.value, obrigatorio:false, descricao: f.label})
    });
    setFiltros(lista)
  }
  else{
    setFiltros([])
  }
};
 
const pickItemTemplate = (item:any) => {
  return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
          <div className="flex-1 flex flex-column gap-2">
              <span className="font-bold">{item.label}</span>
          </div>
      </div>
  );
};
const findTiposFiltros = () => {
  if((selectedTipoConsulta || selectedTipoConsulta === 0) && selectedTipoConsulta !== 4){
    getPermissaoTipoFiltro(selectedTipoConsulta + '').then((data) => {
      if(filtros && filtros.length > 0){
        setSource(data.filter((s1:any) => target.filter((s2:any) => s1.value === s2.value).length === 0))
      }
      else{setSource(data)}
    });
  }
  
}

useEffect(() => {
  setNodes(createPermissoes());
  findTiposFiltros();
},[permission, selectedTipoConsulta])
const getFormErrorMessage = (name:string) => {
type ObjectKey = keyof typeof errors;
const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
};

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-code" style={{ fontSize: '2.0rem' }}></i> {t('permissoes')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        
          
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <PermissaoList date={date} onSelect={(permissionSelect:any) => {if(!permission?.id){ setPermissionDad(permissionSelect)}}} onEdit={(permission:any) => { edit(permission);}} listInactivePermissions={listInactivePermissions}></PermissaoList>
        <Dialog header={t('permissao')} visible={permission} style={{ width: '80vw' }} onHide={() => resetForm()} footer={footerContent}>
          <form id='form-permission' onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
           
            <div>
              <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    
                      <Controller
                          name="identificador"
                          control={control}
                          rules={{
                            required: 'Identificador é Obrigatório',
                            validate: (value) => {
                              if (permissionRef.current?.id) {
                                return true;
                              }
                              const exists = identificadoresRef.current.some(id => id && value && id.toLowerCase() === value.toLowerCase());
                              return !exists || 'Já existe cadastro com esse identificador';
                            }
                          }}
                          render={({ field, fieldState }) => (
                              <>
                                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.identificador })}></label>
                                  <span className="">
                                  <div>
                                    <label htmlFor="identificador" className="font-bold block mb-2 required">{t('identificador')} </label>
                                    <InputText disabled={permission?.id} style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value.replace(/\s/g, ''))} />
                                    </div>
                                  </span>
                                  {getFormErrorMessage(field.name)}
                              </>
                          )}
                      />
                        
                  
                  </div>
                  <div className="col">
                    <Controller
                          name="descricao"
                          control={control}
                          rules={{ required: 'Descrição é Obrigatório' }}
                          render={({ field, fieldState }) => (
                              <>
                                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                                  <span className="">
                                  <div>
                                      <label htmlFor="descricao" className="font-bold block mb-2 required">{t('descricao')} </label>
                                      <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                  </div>
                                  </span>
                                  {getFormErrorMessage(field.name)}
                              </>
                          )}
                      />
                  
                  </div>
              </div>
              <div className="grid">
                  <div className="col">
                    
                      <Controller
                          name="ordenacao"
                          control={control}
                         
                          render={({ field, fieldState }) => (
                              <>
                                  <label htmlFor={field.name} className={classNames({ 'p-error': errors.ordenacao })}></label>
                                  <span className="">
                                  <div>
                                    <label htmlFor="ordenacao" className="font-bold block mb-2">{t('ordenacao')} </label>
                                    <InputNumber mode='decimal' id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.value)} />
                                    </div>
                                  </span>
                                  {getFormErrorMessage(field.name)}
                              </>
                          )}
                      />
                  </div>
                  <div className="col">
                    <Controller
                      name="inativa"
                      control={control}
                      rules={{ validate: value => value !== null || 'Status é Obrigatório' }}
                      render={({ field, fieldState }) => (
                        <>
                          <label htmlFor={field.name} className={classNames({ 'p-error': errors.inativa })}></label>
                          <span className="">
                            <div>
                              <label htmlFor="inativa" className="font-bold block mb-2 required">{t('status')} </label>
                              <Dropdown 
                                style={{ width: '100%' }} 
                                id={field.name} 
                                value={field.value} 
                                className={classNames({ 'p-invalid': fieldState.error })} 
                                onChange={(e) => field.onChange(e.value)} 
                                options={[
                                  { name: 'Ativa', inativa: false }, 
                                  { name: 'Inativa', inativa: true }
                                ]} 
                                optionLabel="name" 
                                placeholder="Selecione o Status" 
                                optionValue='inativa'
                              />
                            </div>
                          </span>
                          {getFormErrorMessage(field.name)}
                        </>
                      )}
                    />
                  </div>
              </div>
              <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="permissaoPai" className="font-bold block mb-2">{t('permissaoPai')} </label>
                    <InputText style={{width:'100%'}} value={permissionDad?.label} disabled />
                  </div>
                  <div className="col">
                    <label htmlFor="permissaoPai" className="font-bold block mb-2">{t('tipoConsulta')} </label>
                    <Dropdown value={selectedTipoConsulta} disabled={permission?.id} onChange={(e) => setselectedTipoConsulta(e.value)} options={tiposConsulta} optionLabel="name" 
                      placeholder="Selecione o tipo Consulta" optionValue='code' style={{width:'100%'}} className="w-full md:w-14rem" />
                  </div>
              </div>
            </div>
            {(selectedTipoConsulta || selectedTipoConsulta === 0 ) && selectedTipoConsulta !== 4  && (
              <div>
                <Panel header="Filtro">
                  <PickList dataKey="value" onChange={(e) => {onChangePickList(e)}} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={false} source={source} target={target}  filter filterBy="label" 
                    sourceHeader="Filtros" targetHeader="Selecionados" sourceStyle={{ height: '14rem' }} targetStyle={{ height: '14rem' }}
                    sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
                  <Divider align="left">
                    <span
                      className="p-tag"
                      style={{ backgroundColor: "#183462", fontSize: "1.1rem" }}
                    >
                      Obrigatório
                    </span>
                  </Divider>
                  <div className="flex-score flex-column gap-3">
                    {filtros.map( (filtro:any) => {
                      return (
                          <div key={filtro.tipoFiltro} className="flex-score align-items-center">
                              <Checkbox inputId={filtro.tipoFiltro} name="obrigatorio" onChange={(e) => {let obrigatorio = false; if(e.checked){obrigatorio = true}else{obrigatorio = false};filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorioMinimo = false; filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorio = obrigatorio;const lista : any[] = []; filtros.map((f)=> lista.push(f)); setFiltros(lista) } } checked={filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorio} />
                              <label htmlFor={filtro.tipoFiltro} className="ml-2">{filtro.descricao}</label>
                              <InputSwitch style={{marginLeft: '2rem'}} disabled={!filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorio} onChange={(e) => {let obrigatorio = false; if(e.value){obrigatorio = true}else{obrigatorio = false}; filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorioMinimo = obrigatorio;const lista : any[] = []; filtros.map((f)=> lista.push(f)); setFiltros(lista) } } checked={filtros.filter((s1:any) => s1.tipoFiltro === filtro.tipoFiltro)[0].obrigatorioMinimo} />
                              <label htmlFor={filtro.tipoFiltro} className="ml-2">Obrigatório pelo menos um</label>
                          </div>
                      )
                    })}
                  </div>
                </Panel>
                
              </div>
            )}
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div className="flex align-items-center">
                      <Checkbox inputId="agrupadorConsulta" onChange={e => setChecked(e.checked? true:false)} checked={checked} disabled={selectedTipoConsulta != 0 && selectedTipoConsulta != 1}/>
                      <label htmlFor="ingredient2" className="ml-2">{t('agruparConsulta')}</label>
                  </div>
                </div>
                
            </div>
            {selectedTipoConsulta !== undefined && selectedTipoConsulta >= 0 && (
              <div className='grid'>
                <div className="col p-fluid flex flex-wrap">
                  <Controller
                        name="fornecedorConsulta"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                                <span className="">
                                <div>
                                    <label htmlFor="forncedor" className="font-bold block mb-2">{t('forncedorConsulta')} </label>
                                    <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                </div>
                <div className="col p-fluid flex flex-wrap">
                  <Controller
                        name="informativo"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.descricao })}></label>
                                <span className="">
                                <div>
                                    <label htmlFor="forncedor" className="font-bold block mb-2">{t('informativo')} </label>
                                    <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                </div>
              </div>
            )}
            {selectedTipoConsulta !== undefined && selectedTipoConsulta >= 0 && (
              <div className='grid'>
                <div className="col">
                  <Controller
                        name="composicaoConsulta"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name} className={classNames({ 'p-error': errors.composicaoConsulta })}></label>
                                <span className="">
                                <div>
                                    <label htmlFor="composicaoConsulta" className="font-bold block mb-2">Composição da Consulta</label>
                                    <InputTextarea style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                </div>
              </div>
            )}
            {checked && (
              <div className='grid'>
                <div className="col p-fluid flex flex-wrap">
                  <div className="flex align-items-center">
                      <Checkbox inputId="bilhetarAgrupador" onChange={e => setBilhetarAgrupador(e.checked? true:false)} checked={bilhetarAgrupador}/>
                      <label htmlFor="bilhetarAgrupador" className="ml-2">{t('bilhetarAgrupador')}</label>
                  </div>
                </div>
              </div>
            )}
            {checked &&  (
              <Tree expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandedKeyss} value={nodes} nodeTemplate={nodeTemplate} selectionMode="checkbox" selectionKeys={selectedKeys} onSelectionChange={(e) => setSelectedKeys(e.value)} />
            )}
            
          </form>
               

        </Dialog>  
      
        
      </div>
                
    </Container>
  )
}
